import React from 'react';
import { format } from 'date-fns';
import { getCustomEventGroupTeeTimes } from 'general/js/helpers';
import { SpriteSvg } from 'project/sprite-svg';

const CustomEventLeaderboardTeeTimeGroup = ({ scoringPlayerRound }) => {
    const teeTime = getCustomEventGroupTeeTimes(
        scoringPlayerRound,
    );
    const formatedTeeTime = teeTime && format(teeTime.replace('Z', ''), 'h:mm a');

    if (!formatedTeeTime) return null;

    return (
        <div className="custom-event-leaderboard__tee-times-group">
            <div className="custom-event-leaderboard__tee-times-group-icon-wrapper">
                <SpriteSvg iconName="clock" width="14" height="14" />
            </div>
            <div className="custom-event-leaderboard__tee-times-group-icon-time">
                {formatedTeeTime}
            </div>
        </div>
    );
};

export default CustomEventLeaderboardTeeTimeGroup;
